import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PostImage from './PostImage';

// https://stackoverflow.com/questions/48088299/how-to-cycle-classname-over-children-in-react/48088571#48088571

class SlideShow extends Component {
  constructor() {
    super();
    this.state = {
      currentSlide: 0,
    };
    this.slides = [];
  }


  componentDidMount() {
    this.slides = this.props.gridCell.content;
    this.slideTimer = setInterval(() => {
      this.setState(prevState => ({ currentSlide: (prevState.currentSlide + 1) % this.slides.length }));
      // modulus operator (remainder) here makes sure currentSlide value doesn't exceed slides.length.
      // If first value is bigger than the second value, the first value will always stay the same: a % b = a if a << b
    }, this.props.gridCell.delay);
  }

  componentWillUnmount() {
    clearInterval(this.slideTimer);
  }

  render() {
    const { gridCell, inViewClass, innerRef } = this.props;

    return (
      <div
        ref={innerRef}
        className={`grid-cell ${gridCell.classes ? gridCell.classes.join(' ') : ''} ${inViewClass}`}
        id={gridCell.id}
        style={gridCell.bgcolor ? { backgroundColor: `#${gridCell.bgcolor}` } : null}
      >
        <div className="slideshow-auto">
          {
            // this.slides.map((slide, i) => (
            gridCell.content.map((contentItem, i) =>(
              <div key={contentItem.id} className={`slide ${i === this.state.currentSlide ? 'showing' : ''}`}>
                <PostImage contentItem={contentItem} />
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

SlideShow.propTypes = {
  gridCell: PropTypes.shape({
    delay: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  inViewClass: PropTypes.string,
  innerRef: PropTypes.func,
};

SlideShow.defaultProps = {
  inViewClass: '',
  innerRef: null,
};

export default SlideShow;



// WEBPACK FOOTER //
// ./src/components/SlideShow.js